import { render, staticRenderFns } from "./regText.vue?vue&type=template&id=221778ac&scoped=true&"
import script from "./regText.vue?vue&type=script&lang=js&"
export * from "./regText.vue?vue&type=script&lang=js&"
import style0 from "./regText.vue?vue&type=style&index=0&id=221778ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221778ac",
  null
  
)

export default component.exports